import React from "react";
import styles from "./DiscussWrapper.module.css";

type DiscussWrapperProps = { children: React.ReactNode };

export default function DiscussWrapper({ children }: DiscussWrapperProps) {
  return <div className={styles.wrapper}>{children}</div>;
}
